import { useSyncExternalStore } from "react";

/**
 * @typedef {Record<string, any>} ActiveGenre
 */

/**
 * @typedef {(updater: ActiveGenre | ((prev: ActiveGenre) => ActiveGenre)) => void} SetActiveGenre
 */

/** @type {ActiveGenre} */
let activeGenre = {};

/** @type {Set<() => void>} */
const listeners = new Set();

/**
 * @returns {ActiveGenre}
 */
export const getActiveGenre = () => activeGenre;

/**
 * @type {SetActiveGenre}
 */
export const setActiveGenre = (updater) => {
  activeGenre = typeof updater === "function" ? updater(activeGenre) : updater;
  listeners.forEach((listener) => listener());
};

const subscribe = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

/**
 * useSyncExternalStore re-reads the value when a component subscribes, so a
 * page that mounts right after the Header sets the genre (e.g. the first click
 * from the home page) still gets it.
 *
 * @returns {[ActiveGenre, SetActiveGenre]}
 */
export const useActiveGenre = () => {
  const state = useSyncExternalStore(subscribe, getActiveGenre);

  return [state, setActiveGenre];
};
